<template lang="pug">
header.v-page-header.page-header.page-header-mobile(v-if="data" :class="{'absolute': !isButtonsVisible}")
	.page-header__buttons(v-if="!isMenuOpen" )
		button.modal-menu__header-link.btn.blur-wrap(v-if="$slots['feedback-form']" @click="showForm")
			.link-inner(v-html="data?.variables?.contact || 'Связаться с нами'" )
			img.page-header__button-img(v-if="data && data.image" :src="data.image")
		.page-header__search(v-if="this.$slots['search']")
			slot(name="search")
		.page-header__compare(v-if="this.$slots['compare']")
			slot(name="compare")
		.blur-wrap(:class="{'visible': isButtonsVisible}" )
			button.burger( type="button" @click="menuHandler")
				.burger__text {{ data?.variables?.menu || "Меню" }}
				.burger__icon
			.blur
		.mobile-burger(:class="{'hide': isButtonsVisible}" @click="menuHandler")
			.mobile-burger__icon
	.modal-menu__aside-modal(v-if="$slots['feedback-form']")
		transition(name="show-aside")
			.aside-modal(v-if="asideOpen")
				.aside-modal__overlay(@click.stop="closeForm")
				.aside-modal__inner.scrollbar
					.aside-modal__body
						button.aside-modal__close(@click.stop="closeForm")
							v-svg-icon.aside-modal__close-icon(icon="cross")
						slot(name="feedback-form")
	transition(name="blur")
		template(v-if="this.$slots['menu']")
			slot(name="menu" :clicked="menuHandler" :isMenuOpen="isMenuOpen" :showForm="showForm")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
import scrollLock from 'scroll-lock';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			isMenuOpen: false,
			isSearchOpen: false,
			isButtonsVisible: false,
			asideOpen: false
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		menuHandler() {
			this.isMenuOpen ? this.isMenuOpen = false : this.isMenuOpen = true
		},

		handleScroll() {
			this.isButtonsVisible = window.scrollY > 100;
		},

		showForm() {
			this.asideOpen = true;
			// scrollLock.enablePageScroll();
			this.$nextTick(() => {
				scrollLock.disablePageScroll(document.querySelectorAll('.aside-modal__inner'));
			})
		},

		closeForm() {
			this.asideOpen = false;
			scrollLock.enablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},
	},

	created() {
		window.addEventListener('scroll', this.handleScroll);

	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	watch: {
		isMenuOpen() {
			this.$nextTick(() => {
				this.isMenuOpen ?
					scrollLock.disablePageScroll(document.querySelector('.modal-menu')) :
					scrollLock.enablePageScroll(document.querySelector('.modal-menu'))
			})

		},

		isSearchOpen() {
			this.isSearchOpen ?
				scrollLock.disablePageScroll(document.querySelector('.modal-search__block')) :
				scrollLock.enablePageScroll(document.querySelector('.modal-search__block'))
		}
	}
};
</script>
